import { api, setAccessToken } from '@/lib/api/client';

import type { AuthUser, LoginPayload, LoginResponse } from './types';

export async function loginApi(payload: LoginPayload): Promise<LoginResponse> {
  const data = await api.post<LoginResponse>('/auth/login', payload);
  if (!data.requiresMfa) {
    setAccessToken(data.accessToken);
  }
  return data;
}

export async function logoutApi(): Promise<void> {
  try {
    await api.post('/auth/logout');
  } finally {
    setAccessToken(null);
  }
}

export async function forgotPasswordApi(email: string): Promise<void> {
  await api.post('/auth/forgot-password', { email });
}

export async function getMeApi(): Promise<AuthUser> {
  return api.get<AuthUser>('/users/me');
}

export async function refreshTokenApi(): Promise<{ accessToken: string }> {
  return api.post<{ accessToken: string }>('/auth/refresh');
}

export async function stopImpersonationApi(): Promise<{ impersonating: false }> {
  return api.post<{ impersonating: false }>('/auth/stop-impersonation', {});
}
